import { inject } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';

import { generateUuid } from '@core/utils-legacy';
import { RequisitionsActions } from '@recruitee/requisitions-data';

import type { CreateRequisitionArgs } from '../requisitions.types';

export class CreateDispatcher {
  private store = inject(Store);
  private actions$ = inject(Actions);

  public execute$(data: CreateRequisitionArgs) {
    const correlationId = generateUuid();
    this.store.dispatch(
      RequisitionsActions.createOnePessimistic({
        payload: { data, correlationId },
      }),
    );
    return this.actions$.pipe(
      ofType(RequisitionsActions.createOnePessimisticSuccess),
      filter(action => action.payload.correlationId === correlationId),
    );
  }
}
